import { motion } from 'framer-motion';

function SkillsBar({ skill, icon,}) {
    return (
        <>
        <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}>
            <div>{icon}</div>
            <div className="text-white text-center mt-2">{skill}</div>
        </motion.div>
        </>
    );
}

export default SkillsBar;
